export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/pages/komship/dashboard/List.vue'),
    meta: {
      resource: 'Dashboard',
      action: 'manage',
    },
  },
]
